var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-section"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.messages),function(message,i){return _c('p',{key:i},[_vm._v(_vm._s(message))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }